import * as types from '../constants/action-types';

export function showPreviousMonth() {
  return (dispatch) => {
    dispatch({ type: types.SHOW_PREVIOUS_MONTH });
  };
}

export function showNextMonth() {
  return (dispatch) => {
    dispatch({ type: types.SHOW_NEXT_MONTH });
  };
}

export function toggleTabs(tabsIndex) {
  return { type: types.UI_TOGGLE_TABS, payload: { tabsIndex } }
}



// WEBPACK FOOTER //
// ./src/actions/ui-actions.js